// Flyer and Flyer Lite products
export const soleProprietorProductSwapMap: { [key: string]: string } = {
    'gid://shopify/ProductVariant/40585344155706': 'gid://shopify/ProductVariant/40585344188474',
    'gid://shopify/ProductVariant/40585339502650': 'gid://shopify/ProductVariant/40585339535418'
};

export const soleProprietorReverseProductSwapMap = Object.fromEntries(
    Object.entries(soleProprietorProductSwapMap).map(([key, value]) => [value, key])
);